module.exports = __webpack_public_path__ + "static/media/carousel-7.b01e35d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel-7.jpg
// module id = 153
// module chunks = 1